(function () {

  'use strict';

  angular.module('eclipseApp').directive('brtIndicator', function() {

    return {
      scope: true,
      templateUrl: 'modules/brt/views/brt-indicator.html',
      restrict: 'E',
      controller: ['$scope', '$state', 'brt', 'env', function($scope, $state, brt, env) {
        $scope.brt = brt;
        $scope.devBRT = function(key) {
          brt.devBRT(key);
          $state.transitionTo($state.current, {}, {reload: true, inherit: false, notify: true});
        };
        $scope.isLocal = function() {
          return env.name === 'local';
        };
        $scope.mockLogin = function() {
          brt.loginAsMockUser();
          $state.transitionTo($state.current, {}, {reload: true, inherit: false, notify: true});
        };
        $scope.cfaLogin = function() {
          //This is safe for production because v1/cfaInfo.json will fail if you are not logged in
          $state.go('cfaLanding', {province: 'ON', language:'en'})
        }
      }]
    };

  });

})();
